<template>
    <div class="wrap">
        <h1>时间戳返还信息确认</h1>
        <p class="des">请确认以下的时间戳返还信息，确认无误后，点击确定返还按钮，系统会自动进行返还操作，<b>并删除对应的证据\文件或证书且无法还原！</b>请谨慎操作！</p>
        <div class="returnInfo">
            <ul>
                <li>
                    <p class="label">用户账号：</p>
                    <p class="cnt">{{ returnOrderInfo.loginName }}</p>
                </li>
                <li>
                    <p class="label">真实名称：</p>
                    <p class="cnt">
                        <TsaTooltip :content="returnOrderInfo.realName">
                            {{ returnOrderInfo.realName }}
                            <div slot="contentBox" class="contentBox">
                                {{ returnOrderInfo.realName }}
                            </div>
                        </TsaTooltip>
                    </p>
                </li>
                <li>
                    <p class="label">消费平台：</p>
                    <p class="cnt">{{ returnOrderInfo.sourceTypeName }}</p>
                </li>
                <li>
                    <p class="label">消费对象：</p>
                    <p class="cnt">{{ returnOrderInfo.name }}</p>
                </li>
                <li>
                    <p class="label">消费个数：</p>
                    <p class="cnt">{{ consumptionCount}}个</p>
                </li>
                <li>
                    <p class="label">消费服务：</p>
                    <p class="cnt">{{ returnOrderInfo.businessTypeName }}</p>
                </li>
                <li>
                    <p class="label">欠费个数：</p>
                    <p class="cnt"><span class="red">{{ returnOrderInfo.oweTsCount }}个</span></p>
                </li>
                <li>
                    <p class="label">消费时间：</p>
                    <p class="cnt">{{ returnOrderInfo.consumedAt | formatDate}}</p>
                </li>
                <li>
                    <p class="label">返还个数：</p>
                    <p class="cnt"><span class="green">{{ returnOrderInfo.returnTsCount }}个</span></p>
                </li>
                <li>
                    <p class="label">欠费流水号：</p>
                    <p class="cnt">{{ returnOrderInfo.oweId || '--' }}</p>
                </li>
                <li class="last">
                    <p class="label">消费流水号：</p>
                    <p class="cnt">
                        {{ returnOrderInfo.consumeIds?returnOrderInfo.consumeIds.join('、') : '--' }}
                    </p>
                </li>
            </ul>
            <div class="table">
                <div class="table-header">
                    需删除文件/证书：{{returnOrderInfo.deleteCount}}个
                </div>
                <el-row class="table-tr" v-for="(item,key) in returnOrderInfo.deleteFiles" :key="key">
                    <el-col class="table-td" :span="22">
                        <TsaTooltip :width="900">
                            {{ item }}
                            <div slot="contentBox" class="contentBox">
                                {{ item }}
                            </div>
                        </TsaTooltip>
                    </el-col>
                    <el-col class="table-td operation" :span="2">
                        <span class="btn" @click="goDetail" v-if="returnOrderInfo.businessType!=='PDF_FORWARD_SERVICE'">查看</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="bnts">
            <span @click="cancelDia=true">放弃</span>
            <span @click="confirmDia=true">确认返还</span>
        </div>
        <el-dialog
            title="重要提示"
            :visible.sync="confirmDia"
            width="430px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <div class="confirmCnt">返还时间戳后，存储在联合信任服务器的以上文件，将被删除，删除之后将无法恢复。请再次确认是否返还？</div>
            <span slot="footer" class="dialog-footer">
                <el-button round class="next" @click="confirmDia=false">取消</el-button>
                <el-button round type="primary" @click="confirmReturn">确定返还</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="cancelDia"
            width="430px"
            top="27vh"
            class="myDialog"
            center
            :before-close="close"
            :close-on-click-modal="false"
        >
            <div class="confirmCnt dialog-content-center">您是否要放弃时间戳返还？</div>
            <span slot="footer" class="dialog-footer">
                <el-button round class="next" @click="cancelDia=false">取消</el-button>
                <el-button round type="primary" @click="cancelReturn">放弃</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="catchDia"
            width="430px"
            top="27vh"
            class="myDialog"
            center
            :before-close="closeGo"
            :close-on-click-modal="false"
        >
            <div class="confirmCnt dialog-content-center">{{ catchMessage }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="closeGo">关闭</el-button>
            </span>
        </el-dialog>
    </div>
    
</template>

<script>
import {getOrderReturnInfo,orderReturnCancel,orderReturnConfirm} from "@http/order/index";
import {businessTypes} from "@/config";
import TsaTooltip from "@/components/TsaTooltip";
export default {
    data () {
        return {
            randomKey:'',
            returnOrderInfo:{},
            confirmDia:false,
            cancelDia:false,
            catchDia:false,
            catchMessage:'',
        }
    },
    components: {TsaTooltip},
    created () {
        this.init()
    },
    watch: {},
    computed: {
        access_token() {
            return this.$store.state.userInfo.userinfo.accessToken
        },
        consumptionCount(){
            if((this.returnOrderInfo.returnTsCount || this.returnOrderInfo.returnTsCount==0) && (this.returnOrderInfo.oweTsCount || this.returnOrderInfo.oweTsCount==0)){
                return this.returnOrderInfo.returnTsCount + this.returnOrderInfo.oweTsCount 
            }else{
                return ''
            }
        }
    },
    mounted () {},
    methods: {
        init(){
            if(this.$route.query.randomKey){
                this.randomKey=this.$route.query.randomKey
                getOrderReturnInfo({randomKey:this.randomKey}).then((res)=>{
                    this.returnOrderInfo=res;
                }).catch((err)=>{
                    if(err.data.code){
                        this.catchMessage=err.data.message
                        this.catchDia=true;
                    }else{
                        this.$msg(err.data.message);
                    }
                })
            }else{
                this.$router.replace({
                    path:'/userAccount/state'
                })
            }
        },
        goDetail(){
            let businessObj = businessTypes.find(obj => obj.value === this.returnOrderInfo.businessType);
            switch(this.returnOrderInfo.sourceType){
                case 954210://权利卫士
                    window.open(process.env.VUE_APP_EV + businessObj.detailUrl + '?id=' + this.returnOrderInfo.businessId + '&evidenceType=' + businessObj.evidenceType);
                    break;
                case 700023://软著
                    window.open(process.env.VUE_APP_COPYRIGHT + businessObj.detailUrl + '?serialNo=' + (this.$route.query.serialNo?this.$route.query.serialNo:this.returnOrderInfo.businessId));
                    break
                case 700025://邮件
                    window.open(process.env.VUE_APP_EMAIL + businessObj.detailUrl + '?serialNo=' + (this.$route.query.serialNo?this.$route.query.serialNo:this.returnOrderInfo.businessId));
                    break
                case 955740://电子证据
                    window.open(process.env.VUE_APP_EV + businessObj.detailUrl + '?id=' + this.returnOrderInfo.businessId);
                    break
                case 952310://知识产权
                    if(this.returnOrderInfo.businessType=='COPYRIGHT_AUTHENTICATION'){
                        window.open(process.env.VUE_APP_COPYRIGHT + businessObj.detailUrl + '?id=' + this.returnOrderInfo.businessId);
                    }else if (this.returnOrderInfo.businessType=='SOFTWARE_COPYRIGHT_AUTHENTICATION'){
                        window.open(process.env.VUE_APP_SOFTWARE + businessObj.detailUrl + '?id=' + this.returnOrderInfo.businessId);
                    }else{
                        window.open(process.env.VUE_APP_COPYRIGHT + businessObj.detailUrl + '?serialNo=' + (this.$route.query.serialNo?this.$route.query.serialNo:this.returnOrderInfo.businessId));
                    }
                    break
                default:
                    this.$msg("无法查看详情");
            }
            
        },
        confirmReturn(){
            orderReturnConfirm({randomKey:this.randomKey}).then((res)=>{
                this.confirmDia=false;
                this.$msg("时间戳返还确认成功", "success");
                this.$router.replace({
                    path:'/userAccount/state'
                })
            }).catch((err)=>{
                if(err.data.code){
                    this.catchMessage=err.data.message
                    this.catchDia=true;
                }else{
                    this.$msg(err.data.message);
                }
            })
        },
        cancelReturn(){
            orderReturnCancel({randomKey:this.randomKey}).then((res)=>{
                this.cancelDia=false;
                this.$msg("时间戳返还已取消", "success");
                this.$router.replace({
                    path:'/userAccount/state'
                })
            }).catch((err)=>{
                if(err.data.code){
                    this.catchMessage=err.data.message
                    this.catchDia=true;
                }else{
                    this.$msg(err.data.message);
                }
            })
        },
        close(){
            this.confirmDia=false
            this.cancelDia=false
        },
        closeGo(){
            this.catchDia=false
            this.$router.replace({
                path:'/userAccount/state'
            })
        }
    }
}
</script>
<style>
.contentBox{
    max-width: 900px;
    line-height: 1.5;
}
</style>
<style lang='less' scoped>
.wrap{
    text-align: center;
    padding-top:40px;
    .red{
        color:#E62623
    }
    .green{
        color:#15CE4B
    }
    h1{
        font-size: 32px;
    }
    .des{
        font-size: 14px;
        margin:24px 0 32px;
        line-height: 1.5;
        b{
            color: #E62623;
        }
    }
    .returnInfo{
        width: 932px;
        margin: 0 auto;
        background: #fff;
        padding: 12px 56px 36px;
        box-sizing: border-box;
        ul{
            display: flex;
            flex-wrap: wrap;
            li{
                display: flex;
                padding: 12px 0;
                align-items: center;
                font-size: 14px;
                width: 50%;
                .label{
                    text-align: left;
                    flex-shrink: 0;
                    width: 94px;
                    color: #5C5F66;
                }
                .cnt{
                    flex: 1;
                    flex-shrink: 0;
                    color: #151B26;
                    display: flex;
                    text-align: left;
                }
                &.last{
                    width: 100%;
                    align-items: flex-start;
                    .cnt{
                        line-height:1.5;
                        max-height: 90px;
                        overflow: auto;
                    }
                }
            }
        }
        .table{
            padding-top: 24px;
            font-size: 14px;
            color: #151B26;
            .table-header{
                height: 40px;
                width: 100%;
                background: #F7F7F9;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 0 13px;
                color: #5C5F66;
                box-sizing: border-box;
            }
            .table-tr{
                height: 40px;
                width: 100%;
                border-bottom: 1px solid #E8E9EB;
                display: flex;
                align-items: center;
                .table-td{
                    padding: 0 13px;
                    display: flex;
                    justify-content: flex-start;
                    &.operation{
                        .btn{
                            color: #2468F2;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    
    .bnts{
        margin-top: 48px;
        display: flex;
        justify-content: center;
        span{
            width:141px;
            height: 46px;
            border-radius: 4px;
            margin:0 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
            color:#fff;
            background: #ccc;
            cursor: pointer;
            &:nth-child(2){
                background: #3D5DF6;
            }
            &:nth-child(1){
                &:hover{
                    background:#e0e0e0
                }
            }
            &:nth-child(2){
                &:hover{
                    background:#536ffd
                }
            }
        }
    }
    .confirmCnt{
        padding-bottom: 25px;
        color: #151B26;
        text-align:justify;
        line-height: 1.5;
    }
    .dialog-footer{
        .el-button{
            min-width: 104px;
        }
    }
}
</style>
<style src="@/assets/css/dialog.less" scoped lang='less'></style>
